import {
  CHAT_FLOW_STEPS,
  ChatAPI,
  setConnectionError,
  setFlowSteps,
  setCurrentChatSession,
  setFlowStep,
} from '@guuru/chat-web';

export default async function (action) {
  const { partnerId, chatId, options } = action;
  const isChat = options?.channel !== 'form';

  const {
    name,
    hasPredictions,
    chatWidgetRequestVisitorRole,
    chatWidgetRequiresName,
    chatWidgetRequiresEmail,
    chatWidgetShowWelcomeMessage,
    chatWidgetShowGreetingMessage,
    quickActions,
    quickActionsSettings,
  } = await ChatAPI.getChatSettings(partnerId);
  const { quickActionSkipIfAdviceQuestion } = quickActionsSettings || {};

  const steps = [];

  if (!name) {
    steps.push(CHAT_FLOW_STEPS.organizationSelection);
    setConnectionError(false);
    setFlowStep();
    setFlowSteps(steps);
    return steps;
  }

  steps.push(CHAT_FLOW_STEPS.chatInit);
  steps.push(CHAT_FLOW_STEPS.chatLoad);
  steps.push(CHAT_FLOW_STEPS.chatStart);
  steps.push(CHAT_FLOW_STEPS.booting);

  if (!quickActionSkipIfAdviceQuestion && isChat && quickActions?.length > 0) {
    steps.push(CHAT_FLOW_STEPS.quickActionSelection);
  }

  if (isChat && chatWidgetShowWelcomeMessage) {
    steps.push(CHAT_FLOW_STEPS.showWelcomeMessage);
  }

  steps.push(CHAT_FLOW_STEPS.chatQuestion);
  if (isChat && chatWidgetShowGreetingMessage) {
    steps.push(CHAT_FLOW_STEPS.greeting);
  }

  if (hasPredictions) {
    steps.push(CHAT_FLOW_STEPS.requestIntentSelection);
    steps.push(CHAT_FLOW_STEPS.makePrediction);
  } else if (quickActionSkipIfAdviceQuestion && isChat) {
    steps.push(CHAT_FLOW_STEPS.quickActionPredict);
    if (quickActions?.length > 0) {
      steps.push(CHAT_FLOW_STEPS.quickActionSelection);
    }
  }

  steps.push(CHAT_FLOW_STEPS.requestCategory);

  if (chatWidgetRequestVisitorRole) {
    steps.push(CHAT_FLOW_STEPS.requestVisitorRole);
  }

  if (chatWidgetRequiresName) {
    steps.push(CHAT_FLOW_STEPS.requestName);
  }

  if (chatWidgetRequiresEmail) {
    steps.push(CHAT_FLOW_STEPS.requestEmail);
  }

  steps.push(CHAT_FLOW_STEPS.connectingExpert);
  steps.push(CHAT_FLOW_STEPS.chat);

  setCurrentChatSession({
    chatId: chatId || ChatAPI.storeRetrieveChatId(partnerId),
  });

  setConnectionError(false);
  setFlowStep();

  ChatAPI.initStorageForNewRequest(partnerId, chatId, options);
  setFlowSteps(steps);
  return steps;
}
